import {
  PRINT_SCORE,
  PRINT_SCORE_FAILURE,
  PRINT_SCORE_SUCCESS,
  //
  PRINT_REVIEW,
  PRINT_REVIEW_SUCCESS,
  PRINT_REVIEW_FAILURE,
  //
  PRINT_BADGE,
  PRINT_BADGE_SUCCESS,
  PRINT_BADGE_FAILURE,
} from "./constants";

export const printScore = (payload, scoreSuccess) => ({
  type: PRINT_SCORE,
  payload,
  scoreSuccess,
});
export const printScoreSuccess = (payload) => ({
  type: PRINT_SCORE_SUCCESS,
  payload,
});
export const printScoreFailure = (payload) => ({
  type: PRINT_SCORE_FAILURE,
  payload,
});

export const printReview = (payload, reviewSuccess) => ({
  type: PRINT_REVIEW,
  payload,
  reviewSuccess,
});
export const printReviewSuccess = (payload) => ({
  type: PRINT_REVIEW_SUCCESS,
  payload,
});
export const printReviewFailure = (payload) => ({
  type: PRINT_REVIEW_FAILURE,
  payload,
});

export const printBadge = (payload, badgeSuccess) => ({
  type: PRINT_BADGE,
  payload,
  badgeSuccess,
});
export const printBadgeSuccess = (payload) => ({
  type: PRINT_BADGE_SUCCESS,
  payload,
});
export const printBadgeFailure = (payload) => ({
  type: PRINT_BADGE_FAILURE,
  payload,
});
